module.exports = __webpack_public_path__ + "static/media/12_Cream_O.0417d92a.png";